<div class="gb-dialog-header edit-category-dialog-header">
  <h1 translate="ITEMS.CATEGORY.EDIT_TITLE"></h1>
</div>
<div class="gb-dialog-content">
  <gb-edit-category
    #editCategoryComponent
    *ngrxLet="selectedItems$ as selectedItems"
    [markFormAsTouched]="markFormAsTouched"
    (itemsSelect)="selectItems($event)"
    [selectedItems]="selectedItems"
  ></gb-edit-category>
</div>

<div class="gb-flex-button-container gb-dialog-actions-container">
  <button mat-stroked-button translate="CANCEL" (click)="closeDialog()"></button>
  <button mat-flat-button (click)="submit()" [disabled]="(editCreateLoaded$ | async) === false">
    <gb-button-loader [loaded$]="editCreateLoaded$">
      <span>{{ 'ITEMS.CATEGORY.EDIT_SUBMIT' | translate }}</span>
    </gb-button-loader>
  </button>
</div>
